import { TableCellTypes } from '@carboledger/ui';
import { makeUnitTypeCell, makeUnitScopedCell } from '@/components/common';
import { buildRowUnitOptions, unitTypeLabel } from './declarationUnits';

// The Allocation details tab — one row per movement out of the declaration.
const renderUnitTypeCell = makeUnitTypeCell((t, row) => buildRowUnitOptions(t, row.byUnit));
const renderAllocatedQty = makeUnitScopedCell('allocatedQty');

export const buildDeclarationAllocationColumns = (t, { unitHeaderSelect }) => [
  {
    id: 'serialNo',
    header: t('FIELD_SERIAL_NO'),
    type: TableCellTypes.text,
    width: 60,
    sortable: true,
  },
  {
    id: 'transactionId',
    header: t('ALLOCATIONS_COL_TRANSACTION_ID'),
    type: TableCellTypes.text,
    width: 130,
    sortable: true,
  },
  {
    id: 'soldTo',
    header: t('FIELD_SOLD_TO'),
    type: TableCellTypes.text,
    width: 130,
    sortable: true,
  },
  {
    id: 'massBalancePeriod',
    header: t('ALLOCATIONS_COL_MASS_BALANCE_PERIOD'),
    type: TableCellTypes.text,
    width: 230,
    sortable: true,
  },
  {
    id: 'unitType',
    header: t('FIELD_UNIT_TYPE', { unit: unitTypeLabel(t, unitHeaderSelect.value) }),
    type: TableCellTypes.custom,
    width: 200,
    cell: renderUnitTypeCell,
    headerSelect: unitHeaderSelect,
    sortable: true,
  },
  {
    id: 'allocatedQty',
    header: t('FIELD_ALLOCATED_QUANTITY'),
    type: TableCellTypes.custom,
    width: 200,
    cell: renderAllocatedQty,
    sortable: true,
  },
  {
    id: 'allocatedQuota',
    header: t('ALLOCATIONS_COL_ALLOCATED_QUOTA'),
    type: TableCellTypes.text,
    width: 273,
    sortable: true,
  },
];
